import { AddressState, NOTIFICATION_STATUS_CODE, NotificationHistoryModel, Notification } from '@evorait/pace-core';
import moment from 'moment/moment';

/**
 * Because we are receiving a flat structure, it is therefore
 * needed to group them by notificationNumber, each group containing
 * a list of associated documents
 *
 * @param rawNotifications
 * @returns Observable<GroupedHistoryNotifications[]> the mapped version
 */
export const getGroupedHistoryNotifications = (
    rawNotifications: NotificationHistoryModel[],
): GroupedHistoryNotifications => {
    const groupedNotifications: GroupedHistoryNotifications = {};

    rawNotifications.forEach((raw) => {
        const key = `${raw.notificationNumber} - ${raw.taskNumber}`;

        if (!groupedNotifications[key]) {
            groupedNotifications[key] = [];
        }
        groupedNotifications[key].push(raw);
    });

    return groupedNotifications;
};

export const getMappedHistoryToNotification = (notificationHistory: NotificationHistoryModel): Notification => {
    return {
        identifier: notificationHistory.identifier,
        languageId: notificationHistory.languageId,
        notificationType: notificationHistory.notificationType,
        functionalLocation: notificationHistory.functionalLoc,
        backendStatus: {
            statusCode: NOTIFICATION_STATUS_CODE.CRM,
            startTime: moment().toISOString(),
            endTime: moment().toISOString(),
        },
        updatedStatus: {
            statusCode: NOTIFICATION_STATUS_CODE.CRM,
            startTime: moment().toISOString(),
            endTime: moment().toISOString(),
        },
        address: {} as AddressState,
        emailSet: [],
        equipmentSet: [
            {
                equnr: notificationHistory.equipmentNumber,
                tidnr: '',
                matnr: notificationHistory.materialNo,
                sernr: notificationHistory.serialNo,
                equiShortDesc: notificationHistory.description,
                division: '',
                mainEquipmentIndicator: '',
            },
        ],
    };
};

export interface GroupedHistoryNotifications {
    [key: string]: NotificationHistoryModel[];
}
